var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeadphoneStand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 113,
    viewBox: "0 0 77 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9843 4.51367L11.6039 9.67223L7.73603 14.8308L3.86816 72.8646L4.5128 94.1437L16.1164 90.2747L18.695 85.761L16.1164 10.3171L19.9843 4.51367Z",
    fill: "#DECCC2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4306 0L68.9771 34.1755L19.9842 7.73784L9.66992 5.80339L18.0503 0.644835L26.4306 0Z",
    fill: "#FDFAF5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4312 0L18.0508 5.15858L68.9776 34.1755L76.7133 29.6617L26.4312 0Z",
    fill: "#FDFAF5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0176 37.4338V33.9244L76.6213 29.8301V32.7546L69.0176 37.4338Z",
    fill: "#E1DCD4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.9671 99.3019L18.6939 85.7607L14.826 91.5641L4.51172 94.1434L27.0742 109.619L30.2975 110.264L44.4796 101.881L39.9671 99.3019Z",
    fill: "#FDFAF7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2975 92.8537L18.6939 85.7607L4.51172 94.1434L30.2975 92.8537Z",
    fill: "#DECCC2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.9769 37.3992L18.6946 9.02711L11.6036 9.67192L7.73571 14.8305L4.51249 94.1433L25.7857 107.685L30.2982 110.264V112.198L0 94.7882L4.51249 12.896L9.02497 5.80301H9.66966L18.05 5.1582L68.9769 34.1751V37.3992Z",
    fill: "#F7F4EF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.4809 103.816L30.2988 112.199V110.264L44.4809 101.882V103.816Z",
    fill: "url(#paint0_linear_2_31227)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_31227",
    x1: 36.1302,
    y1: 105.283,
    x2: 39.2349,
    y2: 110.881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDCCC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6A17A"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphoneStand);
export default __webpack_public_path__ + "static/media/HeadphoneStand.a93537b329cc3ad8b040c352414b3a80.svg";
export { ForwardRef as ReactComponent };